// extracted by mini-css-extract-plugin
module.exports = {"categoryContainer":"CategoryContainer_categoryContainer__kmk_D","category":"CategoryContainer_category__A8BKV","categoryLink":"CategoryContainer_categoryLink__3oSnC"};